import type { PropsWithChildren } from 'react'

export function LinguiProvider({ children }: PropsWithChildren) {
  return <>{children}</>
}
